import React, { Component } from 'react';
import { 
  Dialog,
  Switch,
  Tag,
  Elevation,
  Button,
  Icon,
  FormGroup,
  InputGroup,
  Classes
} from "@blueprintjs/core"
import { connect } from 'react-redux'
import _ from 'lodash'
import { 
  get, 
  add, 
  edit,
  remove
} from '../../../../../actions/keywords'
import Alert from '../../../Alert'
import CategoryDialog from '../CategoryDialog'
import './styles.css'

class Keywords extends Component {
  constructor(props){
    super(props)
    this.state = {
      edit: '',
      id: undefined
    }

    this.onConfirm = this.onConfirm.bind(this)
    this.onAdd = this.onAdd.bind(this)
    this.onRemove = this.onRemove.bind(this)
  }

  componentWillMount(){
    this.props.get()
  }

  onAdd(id = undefined, edit = ''){
    this.setState({
      edit: edit,
      id: id
    }, this.categoryDialog.show)
  }

  onRemove(id){
    this.alert.show()
    .then((response)=>{
      this.props.remove(id)
    }).catch((error)=>{

    })
  }

  onConfirm(value){
    const { id } = this.state
    id ? this.props.edit(id, value) : this.props.add(value)

    this.setState({
      edit: '',
      id: undefined
    })
  }

  render() {
    const { keywords } = this.props

    return (
      <div className="sidebar-categories">
        <Alert 
          ref={(alert)=>(alert && (this.alert = alert))}
          body='Do you want to delete this keyword?'
        />
        <CategoryDialog
          defaultValue={this.state.edit} 
          edit={!!this.state.edit}
          onConfirm={this.onConfirm}
          type='keyword'
          disabledExclude
          ref={(dialog)=>(dialog && (this.categoryDialog = dialog))}
        /> 
        <div className="sidebar-title sidebar-title__left">
          keywords
        </div>
        <div className="sidebarCategoriesContainer">
          {keywords.map((keyword, index)=>{
            return (
              <p className="sidebarTag">
                <span className="sidebarTagName">{keyword.word}</span>
                <span className="sidebarTagEdit" onClick={()=>(this.onAdd(keyword.id, keyword.word))}>
                  <i className="fas fa-pen"></i>
                </span>
                <span className="sidebarTagDelete" onClick={()=>(this.onRemove(keyword.id))}>
                  <i className="fas fa-times"></i>
                </span>
              </p>
            )
          })}
          <Button 
            onClick={()=>(this.onAdd())} 
            minimal="true"
            className="button" >
            <Icon icon="add" elevation={Elevation.TWO} />
          </Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    keywords: state.keywords.keywords
  }
}

export default connect(
  mapStateToProps, { 
  get, add, remove, edit
})(Keywords)



// WEBPACK FOOTER //
// ./src/components/Shared/SidebarContent/components/Keywords/index.js